import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import MatButton from '@mui/material/Button'

const StyledButton = styled(MatButton)``

const Button = ({ children, size, onClick }) => (
  <StyledButton onClick={onClick} variant="contained" size={size}>
    {children}
  </StyledButton>
)

Button.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.string,
  onClick: PropTypes.func,
}

Button.defaultProps = {
  size: 'medium',
  onClick: () => {},
}

export default Button
